// eslint-disable-next-line import/no-duplicates
import Swiper from 'swiper';
// eslint-disable-next-line import/no-duplicates
import PerfectScrollbar from 'perfect-scrollbar';

const psInstances = [];

const createSlider = ($slider) => {
  new Swiper($slider, {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.js-simple-speaker-slider-next',
      prevEl: '.js-simple-speaker-slider-prev',
    },
  });
}

export default function initCrossContentTextSlider() {
  const $container = document.querySelector('.cp-simple-speaker-slider');

  if (!$container) {
    return;
  }

  const psArray = $container.querySelectorAll('.js-simple-speaker-card-description');
  [...psArray].forEach((el) => {
    psInstances.push(new PerfectScrollbar(el, {
      wheelPropagation: true,
    }));
  })

  const $slider = $container.querySelector('.js-simple-speaker-slider')
  if (!$slider) {
    return;
  }

  createSlider($slider)
}
